/* global amp */
var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.AzureNBA = youbora.Adapter.extend({
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  getPlayhead: function () {
    var ret = 0
    if (this.player.cache_.currentTime) {
      ret = this.player.cache_.currentTime
    } else if (this.player.currentMediaTime && typeof this.player.currentMediaTime() === 'number') {
      ret = this.player.currentMediaTime()
    }
    return ret
  },

  getPlayrate: function () {
    var ret = 1
    if (this.player.playbackRate && this.player.playbackRate()) {
      ret = this.player.playbackRate()
    } else if (this.player.tag) {
      ret = this.player.tag.playbackRate
    } else if (this.player.tech_ && this.player.tech_.mediaPlayer) {
      ret = this.player.tech_.mediaPlayer.playbackRate()
    }
    return ret
  },

  getDroppedFrames: function () {
    var playertag = this.player.tech_.mediaPlayer
    if (playertag) return playertag.webkitDroppedFrameCount
    return null
  },

  getDuration: function () {
    return this.player.duration() || this.player.cache_.duration || null
  },

  getBitrate: function () {
    return this.player.currentPlaybackBitrate() || -1
  },

  getThroughput: function () {
    var playertag = this.player.tech_.mediaPlayer
    if (playertag && playertag.videoBufferData) {
      return playertag.videoBufferData._downloadCompleted.measuredBandwidth
    }
    return null
  },

  getRendition: function () {
    var playertag = this.player.tech_.mediaPlayer
    if (playertag && playertag.videoWidth && playertag.videoHeight) {
      return youbora.Util.buildRenditionString(playertag.videoWidth,
        playertag.videoHeight, this.getBitrate())
    }
    return youbora.Util.buildRenditionString(this.getBitrate())
  },

  getTitle: function () {
    return this.player._title || 'unknown'
  },

  getIsLive: function () {
    return this.player.isLive() && this.player.cache_.duration === 0
  },

  getResource: function () {
    return this.player.currentSrc()
  },

  getPlayerName: function () {
    return 'Azure Media Player NBA'
  },

  getPlayerVersion: function () {
    return this.player.getAmpVersion()
  },

  registerListeners: function () {
    this.monitorPlayhead(true, false)
    if (typeof amp !== 'undefined' && this.player) {
      this.references = {}
      this.references[amp.eventName.play] = this.playListener.bind(this)
      this.references[amp.eventName.loadstart] = this.playListener.bind(this)
      this.references[amp.eventName.pause] = this.pauseListener.bind(this)
      this.references[amp.eventName.playing] = this.playingListener.bind(this)
      this.references[amp.eventName.error] = this.errorListener.bind(this)
      this.references[amp.eventName.seeking] = this.seekingListener.bind(this)
      this.references[amp.eventName.seeked] = this.seekedListener.bind(this)
      this.references[amp.eventName.ended] = this.endedListener.bind(this)
      this.references[amp.eventName.timeupdate] = this.timeupdateListener.bind(this)
      this.references[amp.eventName.waiting] = this.bufferingListener.bind(this)
      this.references[amp.eventName.canplaythrough] = this.canplaythroughListener.bind(this)
      for (var key in this.references) {
        this.player.addEventListener(key, this.references[key])
      }
    }
  },

  unregisterListeners: function () {
    if (this.monitor) {
      this.monitor.stop()
    }
    if (this.player && this.references) {
      for (var key in this.references) {
        this.player.removeEventListener(key, this.references[key])
      }
      this.references = {}
    }
  },

  playListener: function (e) {
    if (!this.player.error() && !this.flags.isStarted) {
      this.fireStart()
      this.playingTriggered = false
    }
  },

  pauseListener: function (e) {
    if (!this.flags.isBuffering && !this.flags.isSeeking) {
      this.firePause()
    }
  },

  playingListener: function (e) {
    this.playingTriggered = true
    this.fireResume()
    this.fireSeekEnd()
    this.fireBufferEnd()
    this.fireJoin()
  },

  errorListener: function (e) {
    try {
      var error = this.player.error()
      if (error && error.message && error.message.indexOf('Fragments(audio=') !== -1) {
        // ignoring errors loading audio, to prevent reporting errors twice with both audio and video
        return null
      }
      this.fireError(error.code, error.message)
    } catch (err) {
      this.fireError()
    }
    this.fireStop()
    this.playingTriggered = false
  },

  seekingListener: function (e) {
    this.fireSeekBegin()
  },

  seekedListener: function (e) {
    this.seekedReceived = true
  },

  canplaythroughListener: function (e) {
    if (this.seekedReceived) {
      this.fireSeekEnd()
    }
    this.seekedReceived = false
  },

  endedListener: function (e) {
    this.fireStop()
    this.playingTriggered = false
  },

  timeupdateListener: function (e) {
    if (!this.flags.isJoined) {
      if (!this.player.error()) {
        this.fireStart()
      }
      if (this.playingTriggered) {
        this.fireJoin()
      }
    }
  },

  bufferingListener: function (e) {
    if (!this.flags.isSeeking) {
      this.fireBufferBegin()
    }
  }
})

module.exports = youbora.adapters.AzureNBA
